import { render, staticRenderFns } from "./NavbarSearch.vue?vue&type=template&id=3553a91d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavbarSearch.vue"
export default component.exports